import mock from '@/fake-db/mock.js'

const countries = [
  {
    label: 'All',
    value: 'All',
  },
  {
    label: 'Ghana',
    value: 'Ghana',
  },
]

const regions = [
  {
    label: 'All Regions',
    value: 'All',
    country: 'Ghana',
  },
  {
    label: 'Ahafo',
    value: 'Ahafo',
    country: 'Ghana',
  },
  {
    label: 'Ashanti',
    value: 'Ashanti',
    country: 'Ghana',
  },
  {
    label: 'Bono',
    value: 'Bono',
    country: 'Ghana',
  },
  {
    label: 'Bono East',
    value: 'Bono East',
    country: 'Ghana',
  },
  {
    label: 'Central',
    value: 'Central',
    country: 'Ghana',
  },
  {
    label: 'Eastern',
    value: 'Eastern',
    country: 'Ghana',
  },
  {
    label: 'Greater Accra',
    value: 'Greater Accra',
    country: 'Ghana',
  },
  {
    label: 'North East',
    value: 'North East',
    country: 'Ghana',
  },
  {
    label: 'Northern',
    value: 'Northern',
    country: 'Ghana',
  },
  {
    label: 'Oti',
    value: 'Oti',
    country: 'Ghana',
  },
  {
    label: 'Savannah',
    value: 'Savannah',
    country: 'Ghana',
  },
  {
    label: 'Upper East',
    value: 'Upper East',
    country: 'Ghana',
  },
  {
    label: 'Upper West',
    value: 'Upper West',
    country: 'Ghana',
  },
  {
    label: 'Western',
    value: 'Western',
    country: 'Ghana',
  },
  {
    label: 'Western North',
    value: 'Western North',
    country: 'Ghana',
  },
  {
    label: 'Volta',
    value: 'Volta',
    country: 'Ghana',
  },
]

const towns = [
  {
    label: 'All Towns',
    value: 'All',
    region: 'All',
    country: 'Ghana',
  },
  {
    label: 'Accra',
    value: 'Accra',
    region: 'Greater Accra',
    country: 'Ghana',
  },
  {
    label: 'Bolgatanga',
    value: 'Bolgatanga',
    region: 'Upper East',
    country: 'Ghana',
  },
  {
    label: 'Cape Coast',
    value: 'Cape Coast',
    region: 'Central',
    country: 'Ghana',
  },
  {
    label: 'Dambai',
    value: 'Dambai',
    region: 'Oti',
    country: 'Ghana',
  },
  {
    label: 'Damongo',
    value: 'Damongo',
    region: 'Savannah',
    country: 'Ghana',
  },
  {
    label: 'Goaso',
    value: 'Goaso',
    region: 'Ahafo',
    country: 'Ghana',
  },
  {
    label: 'Ho',
    value: 'Ho',
    region: 'Volta',
    country: 'Ghana',
  },
  {
    label: 'Koforidua',
    value: 'Koforidua',
    region: 'Eastern',
    country: 'Ghana',
  },
  {
    label: 'Kumasi',
    value: 'Kumasi',
    region: 'Ashanti',
    country: 'Ghana',
  },
  {
    label: 'Nareligu',
    value: 'Nareligu',
    region: 'North East',
    country: 'Ghana',
  },
  {
    label: 'Sefwi Wiawso',
    value: 'Sefwi Wiawso',
    region: 'Western North',
    country: 'Ghana',
  },
  {
    label: 'Sekondi-Takoradi',
    value: 'Sekondi-Takoradi',
    region: 'Western',
    country: 'Ghana',
  },
  {
    label: 'Sunyani',
    value: 'Sunyani',
    region: 'Bono',
    country: 'Ghana',
  },
  {
    label: 'Tamale',
    value: 'Tamale',
    region: 'Northern',
    country: 'Ghana',
  },
  {
    label: 'Techiman',
    value: 'Techiman',
    region: 'Bono East',
    country: 'Ghana',
  },
  {
    label: 'Wa',
    value: 'Wa',
    region: 'Upper West',
    country: 'Ghana',
  },
]

mock.onGet('/api/locations/countries').reply(() => {
  return [200, countries]
})

mock.onGet('/api/locations/regions').reply(() => {
  return [200, regions]
})

mock.onGet('/api/locations/towns').reply(() => {
  return [200, towns]
})
